import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/authentication/auth-service.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // const user = this.authService.getCurrentUser();
    const token = localStorage.getItem('token');
    let agence: any = localStorage.getItem('agenceinso');
    agence = agence != null ? JSON.parse(agence) : {};
    request = request.clone({
      setParams: {
        lang: '' + localStorage.getItem('lang') + '',
        a: '' + agence.codeagence != null ? agence?.codeagence : 'SVR' + '',
      },
      // setHeaders:{Authorization: `Bearer ${localStorage.getItem('authToken')}`}
      headers: request.headers.set('Authorization', token ? token : ''),
    });
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => event), // pass further respone
      catchError((error: HttpErrorResponse) => {
        // here will be catched error from response, just check if its 401
        if (error && error.status == 401) {
          // then logout e.g. this.authService.logout()
          // this.authService.logout();
        }
        return throwError(error);
      })
    );
  }
}
